<sb-card [loading]="false">
  <div card-header>
    <b>{{'lang.deviceDetails.playoutsHeadline' | translate}}</b>
  </div>
  <div card-header-more>
    <div class="d-lg-flex align-items-center d-none">
      <button ngbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
              class="btn btn-secondary mr-2" (click)="refresh()">
        <sb-icon icon="refresh"></sb-icon>
      </button>
      <sb-local-date-time-input (modelChange)="handleDateChange($event)"></sb-local-date-time-input>
      <button class="btn btn-primary ml-2" *ngIf="permissionService.hasPermission(permissionService.Permission.device_export_playout)" (click)="export()">
        <sb-icon icon="download"></sb-icon>
        {{'lang.globals.export'|translate}}
      </button>
    </div>
  </div>
  <div card-body>
    <sb-comp-device-playouts
      *ngIf="deviceId && permissionService.hasPermission(permissionService.Permission.device_show)" [date]="date"
      [deviceId]="deviceId" class="tableBg"></sb-comp-device-playouts>
  </div>
</sb-card>
